


















































































import Component from 'vue-class-component';
import Vue from 'vue';
import GenerateLinksCriteria from './generate-links-criteria.vue';
import * as ent from '@/entities';
import linksApi from '@/api/links.api';
import { saveToCliboard } from '@/utils';

@Component({
    components: {
        'generate-links-criteria': GenerateLinksCriteria
    }
})
export default class GenerateLinks extends Vue {
    public items: ent.ILinkModel[] = null;
    public loading: boolean = false;

    public async generate(body: ent.IGetLinkModel) {
        if (!body || !body.agentId) {
            this.items = null;
            return;
        }
        this.loading = true;
        this.items = null;
        try {
            this.items = await linksApi.list(body);
        } finally {
            this.loading = false;
        }
    }

    public save(text: string) {
        saveToCliboard(text);
    }
}
